import qs from 'qs';
import jsBridge from "./jsBridge";

const IOS_SIGN = 1; //iOS标志
const ANDROID_SIGN = 2; //iOS标志
const DEFAULT = '1'; //默认参数值
const PAY_STATUS = ['WX_MOBILE', 'ALI_MOBILE', 'QQ_MOBILE', 'HUAWEI_MOBILE', 'HARMONY_MOBILE'];
export function formatDateTime(timeStamp:any) {
  if(!timeStamp) return ''

  let date = new Date(timeStamp);
  let y = date.getFullYear();
  let m:any = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  let d:any = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h:any = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let minute:any = date.getMinutes();
  let second:any = date.getSeconds();
  minute = minute < 10 ? ('0' + minute) : minute;
  second = second < 10 ? ('0' + second) : second;
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
}

export function formatDate(timeStamp:any, type = 1) {
  //type  1 年月日   2 用点分隔
  let date = new Date(timeStamp);
  let y = date.getFullYear();
  let m:any= date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  let d:any = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  if (type === 1) {
    return y + '年' + m + '月' + d + '日';
  } else if (type === 2) {
    return y + '.' + m + '.' + d;
  }
}

/*查询参数*/
export function getQueryString(name:string) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

export function _IsAS() {
  var ua = navigator.userAgent.toLowerCase();
  if (/(iPhone|iPad|iPod|iOS|Mac)/i.test(navigator.userAgent)) {
    return 1;
  } else if (ua.match(/Android/i)) {
    return 2;
  } else if (ua.match(/Harmony/i)) {
    return 3;
  }
}

// 获取cookie字符串
export function getCookie(name:string) {
  const cookie = document.cookie;
  const r = new RegExp(name + '=([^,]*)');

  const match = cookie.match(r);
  if (match) {
    return match[1];
  }
  return '';
}
//获取神策数据，是否第一次登录
export function getISfristDay() {
  let host = window.location.host.replace(/\./g, '_');
  if (getCookie(`sajssdk_2015_new_user_${host}`) || getCookie('sajssdk_2015_root_new_user') || getCookie('sajssdk_2015_cross_new_user')) {
    return '1';
  }
  return '0'
}
//检查版本号（即将弃用）
export function checkVersion() {
  let version = getCookie('zwzt_version');
  let strList = version.split('.');
  if (Number(strList[1]) < 2) {
    return 'FAIL'
  } else if (Number(strList[1]) > 2) {
    return 'SUCCESS'
  } else if (strList[1] === '2' && strList[2] === '0') {
    return 'FAIL'
  } else if (strList[1] === '2' && strList[2] === '1') {
    return 'SUCCESS'
  } else {
    return 'SUCCESS'
  }
}
//外链跳回app
export function openappfunc(url:string) {
  let schemeUrl = 'zuowenzhitiao://com.qihe';
  let webviewUrl = `${schemeUrl}?routerUrl=${encodeURIComponent(`zuowenzhitiao://main/webView?url=${encodeURIComponent(url)}`)}`
  openApp(webviewUrl);
}
export function navigortApp(url:string){
  let schemeUrl = 'zuowenzhitiao://com.qihe';
  let webviewUrl = `${schemeUrl}?routerUrl=${encodeURIComponent(`zuowenzhitiao://main/webView?url=${encodeURIComponent(url)}`)}`
  window.location.href = webviewUrl;
}
export function isEquipment() {
  let UA = navigator.userAgent,
    isAndroid = /android|adr|linux/gi.test(UA),
    isIOS = /iphone|ipod|ipad/gi.test(UA) && !isAndroid,
    isBlackBerry = /BlackBerry/i.test(UA),
    isWindowPhone = /IEMobile/i.test(UA),
    isMobile = isAndroid || isIOS || isBlackBerry || isWindowPhone;
  return {
    isAndroid: isAndroid,
    isIOS: isIOS,
    isMobile: isMobile,
    isWeixin: /MicroMessenger/gi.test(UA),
    isQQ: /QQ/gi.test(UA),
    isPC: !isMobile,
    isWeibo: /WeiBo/gi.test(UA)
  }
}

export function openApp(localUrl:string) {
  var downUrl = '';
  let _document: any = document;
  if (_IsAS() === 1) {
    if (isEquipment().isWeibo || isEquipment().isWeixin || isEquipment().isQQ) {
      _document.querySelector('.middle_page').classList.remove('hide').add('show');
      _document.querySelector('.open_ua_img').classList.remove('hide').add('show');
    } else {
      downUrl = 'https://apps.apple.com/cn/app/id1207254643';
      //判断是否是ios,具体的判断函数自行百度
      window.location.href = localUrl;
      setTimeout(function () {
        window.location.href = downUrl;
      }, 2000);
    }
  } else if (_IsAS() === 2) {
    if (isEquipment().isWeixin) {
      downUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=zwzt.fangqiu.edu.com.zwzt&ckey=CK1441280218858';
    } else if (isEquipment().isQQ) {
      downUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=zwzt.fangqiu.edu.com.zwzt&ckey=CK1441283115905';
    } else {
      downUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=zwzt.fangqiu.edu.com.zwzt&ckey=CK1441367392706';
    }
    if (isEquipment().isWeibo || isEquipment().isWeixin) {
      _document.querySelector('.middle_page').classList.remove('hide').add('show');
    } else if (isEquipment().isQQ) {
      window.location.href = localUrl;
      // setTimeout(function () {
      //   window.location.href = downUrl;
      // }, 2000);
    } else {
      // // uc无法自动唤起
      window.location.href = localUrl;
      // setTimeout(function () {
      //   window.location.href = downUrl;
      // }, 2000);
    }
    // _document.querySelector('.naviBox').classList.remove('hide');
  } else {
    window.location.href = 'http://www.zuowenzhitiao.com/'
  }
}

export function downloadApp() {
  // 先判断微信在判断qq
  if (_IsAS() === 1) {
    window.location.href = 'https://apps.apple.com/cn/app/id1207254643';
  } else if (_IsAS() === 2) {
    if (isEquipment().isWeixin) {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=zwzt.fangqiu.edu.com.zwzt&ckey=CK1441280218858';
    } else if (isEquipment().isQQ) {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=zwzt.fangqiu.edu.com.zwzt&ckey=CK1441283115905';
    } else {
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=zwzt.fangqiu.edu.com.zwzt&ckey=CK1441367392706';
    }
  } else {
    window.location.href = 'https://www.zuowenzhitiao.com/';
  }
}

//格式化倒数时间
//nowTime:现在时间戳，endTime：停止时间戳
export function formatCountDown(nowTime:any, endTime:any) {
  if (nowTime >= endTime) return { hours: '00', minute: '00', second: '00' };
  let diffSeconds: any = parseInt(((endTime - nowTime) / 1000).toString());
  let second:any = parseInt((diffSeconds % 60).toString());
  let minute:any = parseInt((diffSeconds / 60).toString()) % 60;
  let hours:any = parseInt((diffSeconds / 3600).toString());
  second = second < 10 ? '0' + second : second;
  minute = minute < 10 ? '0' + minute : minute;
  hours = hours < 10 ? '0' + hours : hours;
  return { hours, minute, second };

}
//设置夜间模式
export function setDayorNight() {
  let _document:any = document;
  if (getCookie('zwzt_night') === '1') {
    _document.querySelector('html').style.background = '#2B2A34';
    if (document.getElementsByTagName('body')[0].className.indexOf('zwzt_night') === -1) {
      document.getElementsByTagName('body')[0].classList.remove('zwzt_day');
      document.getElementsByTagName('body')[0].classList.add('zwzt_night');
    }
  } else {
    _document.querySelector('html').style.background = '#FFFFFF';
    if (document.getElementsByTagName('body')[0].className.indexOf('zwzt_day') === -1) {
      document.getElementsByTagName('body')[0].classList.remove('zwzt_night');
      document.getElementsByTagName('body')[0].classList.add('zwzt_day');
    }
  }
}

//调起支付
//参数：order: 订单，type: 支付类型
export function callPay(order:any, channelId:any) {
  let type = PAY_STATUS[channelId - 1];
  if (_IsAS() === IOS_SIGN) {
    window &&
      (window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.callPay &&
      (window as any).webkit.messageHandlers.callPay.postMessage(JSON.stringify({ order, type }));
  } else if (_IsAS() === ANDROID_SIGN) {
    window &&
      (window as any).android &&
      (window as any).android.callPay(order, type);
  } else if (_IsAS() === 3) {
      window?.harmony?.callPay(order, type);
  }
}
export function callLogin(sign = DEFAULT) {
  if (_IsAS() === IOS_SIGN) {
    window &&
      (window as any).webkit &&
      (window as any).webkit.messageHandlers &&
      (window as any).webkit.messageHandlers.LoginModel &&
      (window as any).webkit.messageHandlers.LoginModel.postMessage(sign);
  } else if (_IsAS() === ANDROID_SIGN) {
    window &&
      (window as any).android &&
      (window as any).android.callLogin(sign);
  } else if (_IsAS() === 3) {
      window?.harmony?.callLogin(sign);
  }
};


export var EventUtil = {
  addHandler: function (element:any, type:any, handler:any) {
    if (element.addEventListener)
      element.addEventListener(type, handler, false);
    else if (element.attachEvent)
      element.attachEvent("on" + type, handler);
    else
      element["on" + type] = handler;
  },
  removeHandler: function (element:any, type:any, handler:any) {
    if (element.removeEventListener)
      element.removeEventListener(type, handler, false);
    else if (element.detachEvent)
      element.detachEvent("on" + type, handler);
    else
      element["on" + type] = handler;
  },
  /**
   * 监听触摸的方向
   * @param target            要绑定监听的目标元素
   * @param isPreventDefault  是否屏蔽掉触摸滑动的默认行为（例如页面的上下滚动，缩放等）
   * @param upCallback        向上滑动的监听回调（若不关心，可以不传，或传false）
   * @param rightCallback     向右滑动的监听回调（若不关心，可以不传，或传false）
   * @param downCallback      向下滑动的监听回调（若不关心，可以不传，或传false）
   * @param leftCallback      向左滑动的监听回调（若不关心，可以不传，或传false）
   */
  listenTouchDirection: function (target:any, isPreventDefault:any, upCallback:any, rightCallback:any, downCallback:any, leftCallback:any) {
    this.addHandler(target, "touchstart", handleTouchEvent);
    this.addHandler(target, "touchend", handleTouchEvent);
    this.addHandler(target, "touchmove", handleTouchEvent);
    let startX:any;
    let startY:any;
    function handleTouchEvent(event:any) {
      switch (event.type) {
        case "touchstart":
          startX = event.touches[0].pageX;
          startY = event.touches[0].pageY;
          break;
        case "touchend":
          var spanX = event.changedTouches[0].pageX - startX;
          var spanY = event.changedTouches[0].pageY - startY;

          if (Math.abs(spanX) > Math.abs(spanY)) {      //认定为水平方向滑动
            if (spanX > 30) {         //向右
              if (rightCallback)
                rightCallback();
            } else if (spanX < -30) { //向左
              if (leftCallback)
                leftCallback();
            }
          } else {                                    //认定为垂直方向滑动
            if (spanY > 30) {         //向下
              if (downCallback)
                downCallback();
            } else if (spanY < -30) {//向上
              if (upCallback)
                upCallback();
            }
          }

          break;
        case "touchmove":
          //阻止默认行为
          if (isPreventDefault)
            event.preventDefault();
          break;
        default:
         break;
      }
    }
  }
};

//antd 弹框默认事件
function closest(el:any, selector:any) {
  const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

export function onWrapTouchStart(e:any) {
  // fix touch to scroll background page on iOS
  if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
    return;
  }
  const pNode = closest(e.target, '.am-modal-content');
  if (!pNode) {
    e.preventDefault();
  }
}
//格式化价格
export function toDecimal2(x:any) {
  let f = parseFloat(x);
  if (isNaN(f)) {
    return false;
  }
  let h = Math.round(x * 100) / 100;
  let s = h.toString();
  let rs = s.indexOf('.');
  if (rs < 0) {
    rs = s.length;
    s += '.';
  }
  while (s.length <= rs + 2) {
    s += '0';
  }
  return s;
}
//分转元
export function regFenToYuan(fen:any, decimal: 1 | 2 = 2, deleteZero=false) {
  let num = fen;
  num = fen * 0.01;
  num += '';
  let reg = num.indexOf('.') > -1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g;
  num = num.replace(reg, '$1');
  num = toDecimal2(num)

  if(typeof num === 'string') {
    let n = num.split('.')[1].slice(0, decimal)
    if(deleteZero && Number(n) === 0) {
      num = num.split('.')[0]
    }else if(decimal === 1) {
      num = num.slice(0, num.length - 1)
    }
  }

  return num
}
//元转分
export function regYuanToFen(yuan:any, digit = 100) {
  let m = 0;
  let s1 = yuan.toString();
  let s2 = digit.toString();
  try { m += s1.split(".")[1].length } catch (e) { }
  try { m += s2.split(".")[1].length } catch (e) { }
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
}

export function getDecimal(num: number | string, count = 2) {
    if(typeof num === 'string') num = Number(num)
    
    const n = Math.pow(10,count)
    console.log(Math.floor(num * n))
    return (Math.floor(num * n) / n)
}

//兼用安卓window.replace 跳转
export function locationReplace(url:string) {
  if (window.history.replaceState) {
    window.history.replaceState(null, document.title, url);
    window.history.go(0);
  } else {
    window.location.replace(url);
  }
}
//检查版本号
export function compareVersionEle(targetVerison:string) {
  let currVersion = getCookie('zwzt_version');
  //currVersion  当前版本
  //targetVerison  目标版本
  if (!targetVerison) return false;
  const curr = currVersion.split('.');
  const target = targetVerison.split('.');
  for (let i = 0; i < curr.length; i++) {
    if (parseInt(curr[i]) > parseInt(target[i])) {
      return true
    }
    if (parseInt(curr[i]) < parseInt(target[i])) {
      return false
    }
    //相等继续
    //parseInt(curr[i]) == parseInt(target[i])  continue
  }
  return true
}
//序列化URL后的参数
export function qsStringifyUrl(url:string, data:any) {
  Object.keys(data).map((key) => {
    if (data[key] === '') {
      delete data[key];
    }
    return key;
  })
  let dataUrl = qs.stringify(data);
  let href = `${url}?${dataUrl}`;
  return href;
}
export function paramsFilter(data: any){
  let dataUrl = qs.stringify(data);
  return dataUrl;
}
//查看是否已经登录
export function checkLogin() {
  return new Promise<void>((resolve, reject) => {
    if (getCookie('zwzt_code') === '') {
      reject()
    } else {
      resolve();
    }
  })
}

export const srollFunction:any = {
  scrollTop: null,
  doc: null,
  reg: null,
  bodyClassName: '',
  afterOpen: (bodyEle:any, bodyCls:string) => {
    srollFunction.doc = document.documentElement.scrollTop ? document.documentElement : bodyEle;
    srollFunction.scrollTop = srollFunction.doc.scrollTop;

    if (bodyEle.classList) {
      bodyEle.classList.add(bodyCls)
    } else {
      bodyEle.className += " " + bodyCls;
    }

    bodyEle.style.top = -srollFunction.scrollTop + 'px';
    srollFunction.bodyClassName = bodyEle.className;
  },
  beforeClose: (bodyEle:any, bodyCls:string) => {
    if (bodyEle.classList) {
      bodyEle.classList.remove(bodyCls)
    } else {
      srollFunction.reg = new RegExp("\\b" + bodyCls + "\\b", "gi");
      if (srollFunction.reg.test(srollFunction.bodyClassName)) {
        srollFunction.bodyClassName = srollFunction.bodyClassName.replace(srollFunction.reg, "");
        bodyEle.className = srollFunction.bodyClassName;
      }
    }

    bodyEle.style.top = "";
    srollFunction.doc.scrollTop = srollFunction.scrollTop;
  }
}

export function scrollMore(isBtn:boolean) {
  return new Promise((resolve, reject) => {
    let scrollTop = window.scrollY + document.documentElement.clientHeight;
    let pageHeight = document.body.scrollHeight;
    // 判断是否到底，是否可以加载下一页
    if (scrollTop >= pageHeight - 100 && isBtn) {
      resolve('')
    }
  })
}

export const compatibleVersionHerf = (url: string, type = 1) => {
  //type 1需要拼接window.localtion.origin   2不需要拼接
  //检验是否5.3.0及以上版本，5.3.0以下的版本用location.href跳转，以上的版本用路由跳转
  if (compareVersionEle('5.3.0')) {
      let urls = type === 1 ? `${window.location.origin}${url}` : url;
      let hrefUrl = encodeURIComponent(urls);
      jsBridge.routerToNativePage(hrefUrl);
  } else {
      window.location.href = url;
  }
}

//查看是否已经登录
export function checkInnerApp(): boolean {
  return getCookie('zwzt_version') === '' ? false : true
}
export function loadJs(url:string,callback:any){
  let script:any = document.createElement('script');
  script.type="text/javascript";
  if(typeof(callback)!="undefined"){
    if(script.readyState){
      script.onreadystatechange=function(){
        if(script.readyState == "loaded" || script.readyState == "complete"){
          script.onreadystatechange=null;
          callback();
        }
      }
    }else{
      script.onload = function(){
        callback();
      }
    }
  }
  script.src = url;
  document.body.appendChild(script);
}

export const isHarmony = _IsAS() == 3;
export const isLowVersionHarmony = isHarmony && !compareVersionEle('6.3.10');